module.exports = __webpack_public_path__ + "img/basic_restorejelset_202308.0e05b6a0.jpg";